class Accordion extends HTMLElement {
  constructor() {
    super();

    this.listeners();
  }

  listeners() {
    let accordions = document.querySelectorAll(".product__accordion");

    accordions.forEach((el) => {
      const accordionHeaders = el.querySelectorAll(".accordion__header");
      const openFirstItem = el.getAttribute("data-open-first") === "true";

      if (openFirstItem === true) {
        const firstItem = el.querySelector(".accordion__item");

        if (firstItem) this.openFirstItem(firstItem);
      }

      accordionHeaders.forEach(el => el.addEventListener("click", this.accordionClickEvent));
    });
  }

  openFirstItem(el) {
    !el.classList.contains("accordion__item--open") ? Accordion.openAccordion(el, true) : null;
  }

  accordionClickEvent() {
    const accordionItem = this.closest(".accordion__item");
    const accordionContainer = this.closest(".product__accordion");
    const mobileOnly = accordionContainer.getAttribute("data-mobile-only") === "true";
    const touchOnly = accordionContainer.getAttribute("data-touch-only") === "true";

    const mediaQuery = window.matchMedia("(max-width: 989px)");

    if (mobileOnly || touchOnly) {
      if (mediaQuery.matches) Accordion.toggleStates(accordionContainer, accordionItem);
    } else {
      Accordion.toggleStates(accordionContainer, accordionItem);
    }
  }

  // Toggle active states of clicked accordion
  static toggleStates(container, item) {
    const wrapper = container.closest(".js-accordion-container");
    const parent = container.parentNode;
    const accordionItems = (wrapper || parent).querySelectorAll(".accordion__item");
    const autoClose = container.getAttribute("data-auto-close") === "true";

    if (!item.classList.contains("accordion__item--open")) {
      if (autoClose === true) {
        accordionItems.forEach(el =>
          el.classList.contains("accordion__item--open")
            ? this.closeAccordion(el)
            : null
        );
      }

      // Duration of animation
      setTimeout(() => this.openAccordion(item), 250);
    } else {
      this.closeAccordion(item);
    }
  }

  static openAccordion(el) {
    el.classList.add("accordion__item--open");

    const header = el.querySelector(".accordion__header");
    const content = el.querySelector(".accordion__content");
    const width = getComputedStyle(content).width;

    header.setAttribute("aria-expanded", "true");

    // Set properties to calculate height whilst hiding element
    content.style.width = width;
    content.style.position = 'absolute';
    content.style.visibility = 'hidden';
    content.style.height = 'auto';

    const height = getComputedStyle(content).height;

    // Reset properties used above to calculate height
    content.style.width = null;
    content.style.position = null;
    content.style.visibility = null;
    content.style.height = "0";

    // Force repaint
    getComputedStyle(content).height;
    requestAnimationFrame(() => content.style.height = height);

    content.addEventListener("transitionend", () => {
      if (el.classList.contains("accordion__item--open")) content.style.height = "auto";
    });
  }

  static repositionViewport(el) {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const offset = document.documentElement.scrollTop;
    const target = el.getBoundingClientRect().top;
    const header = document.documentElement.style.getPropertyValue("--header-height");

    let stickyHeader = 0

    if (!isMobile) stickyHeader = document.querySelector(".sticky-bag").getBoundingClientRect().top;

    const y = target + offset - header.replace("px", "") - stickyHeader;

    requestAnimationFrame(() => window.scrollTo({ top: y , behavior: "smooth" }));
  }

  static closeAccordion(el) {
    el.classList.remove("accordion__item--open");

    const header = el.querySelector(".accordion__header");
    const content = el.querySelector(".accordion__content");

    header.setAttribute("aria-expanded", "false");

    content.style.height = getComputedStyle(content).height;

    // Force repaint
    getComputedStyle(content).height;

    requestAnimationFrame(() => content.style.height = "0");
  }
}

customElements.define("accordion-wrapper", Accordion);
